import classes from "../../../scss/Post.module.scss";
import noImage from "../../../assets/img/noImage.png";
import { Link } from "react-router-dom";

const PreviewPost = ({ post }) => {
  return (
    <Link className={classes.preview_post} to={`/posts/${post.slug}`}>
      <div className={classes.preview_post__image}>
        <img src={post?.img_url.full || noImage} alt={post?.title.rendered} />
      </div>
      <div className={classes.preview_post__title}>{post.title.rendered}</div>
      <div className={classes.preview_post__date}>
        <span>
          {new Date(post?.date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </span>
        <span>
          {post?._embedded["wp:term"][1][0]?.name.trim() || "Agilistry"}
        </span>
      </div>
    </Link>
  );
};
export default PreviewPost;
